import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Follow these steps to create a new site using the `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/gatsby-cli/"
      }}>{`Gatsby CLI`}</a>{`:`}</p>
    <Note mdxType="Note">
      <p>{`This guide assumes that you have some familiarity with the command line, and have Node.js and npm installed locally. Check out `}<a parentName="p" {...{
          "href": "https://nodejs.org"
        }}>{`nodejs.org`}</a>{` for more information. You will need npm v5.2.0 or higher to use the `}<a parentName="p" {...{
          "href": "https://blog.npmjs.org/post/162869356040/introducing-npx-an-npm-package-runner"
        }}><inlineCode parentName="a">{`npx`}</inlineCode></a>{` command in step 1.`}</p>
    </Note>
    <h2>{`1. Scaffold a new site`}</h2>
    <p>{`Use the Gatsby CLI and the Doctocat starter to scaffold a new site:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npx gatsby new my-site https://github.com/primer/doctocat-starter
`}</code></pre>
    <p><inlineCode parentName="p">{`my-site`}</inlineCode>{` is an arbitrary title — you can pick anything. Running the above command will place the code for your new site in a new directory called “my-site”. If you want to create a new site in an existing repository, be sure to run the `}<inlineCode parentName="p">{`gatsby new`}</inlineCode>{` command from within that repository.`}</p>
    <h2>{`2. Navigate into the site directory`}</h2>
    <p>{`Navigate into the newly created site directory using `}<inlineCode parentName="p">{`cd`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`cd my-site
`}</code></pre>
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "/doctocat/getting-started"
      }}>{`getting started guide`}</a>{` for more information about the important files and subdirectories in your new site directory.`}</p>
    <h2>{`3. Start the development server`}</h2>
    <p>{`Use the `}<inlineCode parentName="p">{`develop`}</inlineCode>{` npm script to start Gatsby's hot-reloading development environment:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm run develop
`}</code></pre>
    <p>{`To view your site locally, navigate to http://localhost:8000 in your browser. Each page of the site corresponds to a file in the `}<inlineCode parentName="p">{`content`}</inlineCode>{` directory. Navigate to any page then try editing the corresponding MDX file. You should see the page update in real time.`}</p>
    <h2>{`What's next?`}</h2>
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "/doctocat/usage/customization"
      }}>{`customization`}</a>{` and `}<a parentName="p" {...{
        "href": "/doctocat/usage/deployment"
      }}>{`deployment`}</a>{` guides.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      